const DC_NAMES = {
  la: 'Los Angeles',
  ny: 'New York',
  at: 'Atlanta',
  dl: 'Dallas',
  ir: 'Irvine',
  ch: 'Chicago',
};

export function normalizeDatacenter(value) {
  return value ? String(value).trim().toLowerCase() : '';
}

export function datacenterLabel(value) {
  const key = normalizeDatacenter(value);
  if (!key) return 'Unknown';
  return DC_NAMES[key] || key.toUpperCase();
}

export function datacentersDiffer(sourceDc, destDc) {
  const source = normalizeDatacenter(sourceDc);
  const dest = normalizeDatacenter(destDc);
  return Boolean(source && dest && source !== dest);
}

export function destinationDcMismatchMessage(sourceDc, destDc) {
  return (
    `The destination device is registered to ${datacenterLabel(destDc)}. ` +
    `It will be switched to the source data center (${datacenterLabel(sourceDc)}) before the swap. ` +
    `The destination device will go offline briefly and must come back online. Do you want to continue?`
  );
}

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

export async function waitForBoxOnline(fetchBox, boxId, options = {}) {
  const initialDelayMs = options.initialDelayMs == null ? 60000 : options.initialDelayMs;
  const timeoutMs = options.timeoutMs == null ? 60000 : options.timeoutMs;
  const intervalMs = options.intervalMs == null ? 5000 : options.intervalMs;

  if (initialDelayMs > 0) await wait(initialDelayMs);

  const deadline = Date.now() + timeoutMs;
  let latest = await fetchBox(boxId);
  if (latest && latest.apiOnline) return latest;

  while (Date.now() < deadline) {
    await wait(intervalMs);
    latest = await fetchBox(boxId);
    if (latest && latest.apiOnline) return latest;
  }
  return latest && latest.apiOnline ? latest : null;
}

export async function alignDestinationDatacenter({
  token,
  dispatch,
  destBoxId,
  sourceDatacenter,
  fetchBoxById,
  updateEpikBox,
}) {
  const destBox = await dispatch(fetchBoxById(token, destBoxId));
  if (!destBox || !destBox._id) {
    return { ok: false, reason: 'Could not load the destination device.' };
  }

  const currentDc = normalizeDatacenter(destBox.datacenter);
  const targetDc = normalizeDatacenter(sourceDatacenter);
  if (!targetDc) {
    return { ok: false, reason: 'Source data center is missing.' };
  }
  if (currentDc === targetDc) {
    return { ok: true, alreadyAligned: true };
  }

  const switched = await dispatch(
    updateEpikBox(token, {
      ...destBox,
      datacenter: targetDc,
    })
  );
  if (!switched) {
    return { ok: false, reason: 'Failed to switch the destination data center.' };
  }

  const onlineBox = await waitForBoxOnline(id => dispatch(fetchBoxById(token, id)), destBoxId);
  if (!onlineBox) {
    return {
      ok: false,
      timedOut: true,
      reason:
        'The destination data center was switched, but the device is still coming online. Try Device Swap again once it is online.',
    };
  }
  return { ok: true };
}
